import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'route-info-modal',
  templateUrl: './route-info-modal.component.html',
  styleUrls: ['./route-info-modal.component.css'],
})
export class RouteInfoModalComponent {
  @Input() routeData: any;
  @Input() canRecalculate = false;

  @Output() reloadRequested = new EventEmitter<void>();
  @Output() recalculateRequested = new EventEmitter<void>();

  sortTimeAscending = false;

  toggleSortByTime() {
    this.sortTimeAscending = !this.sortTimeAscending;
    const direction = this.sortTimeAscending ? 1 : -1;
    this.routeData.sort(
      (a: any, b: any) =>
        direction *
        (RouteInfoModalComponent.timeToSeconds(a.strTime) -
          RouteInfoModalComponent.timeToSeconds(b.strTime)),
    );
  }

  exportExcel(tableId: string): void {
    const element = document.getElementById(tableId);
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'info.xlsx');
  }

  private static timeToSeconds(time: string): number {
    const parts = (time || '').split(':').map(Number);
    if (parts.length < 3 || parts.some(isNaN)) return 0;
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }
}
